import { ICardPrintingDiplomas } from './types'

import { IconClearClose } from '@img/icons'
import logoYaSkill from '@img/logo_yaskill.svg'
import logoModSkill from '@img/logo_modskill.svg'
import { SelectDate } from '@primitive/calendar'
import { getInputButton } from '@primitive/getInputButton'
import { DictSelectorContainer } from '@smart/dictSelector'
import { Flex, Modal, Loader, Input, Button } from '@ui/index'

import css from './ui.module.scss'


/** Анкета печати документа */
export const CardPrintingDiplomas = ({
    isOpen, isLoadingCard, isDisableBtnSave, fieldsError, loadingTitle, fullNameFrom, dataBase,
    txtPrintStatus, txtDiplomRegNumber, txtDiplomNumber, txtDiplomDate, txtPrintStatusID,
    handlerBtnSave, handlerOpenModalConfirm, handleBtnClose
}: ICardPrintingDiplomas) => {
    const siteLogo = dataBase === 'yaskill'
        ? {src: logoYaSkill, name: 'YaSkill'}
        : dataBase === 'modern_academy'
            ? {src: logoModSkill, name: 'ModSkill'}
            : null

    return <Modal isOpen={isOpen} isEsc onCancel={handleBtnClose} maxWidth='600px'>
        <Flex className='modal_container'>
            <Flex flexDirection="row" alignItems="center" justifyContent="space-between" className='modal_container-header'>
                <header>
                    <Flex gap='4px' flexDirection='row' alignItems='center'>
                        {siteLogo && <img className={css['header_logo']} src={siteLogo.src} alt={`Логотип ${siteLogo.name}`} />}
                        <h4>Анкета печати</h4>
                    </Flex>

                    <h5>{fullNameFrom}</h5>
                </header>

                <Button variant='icon' size='md' isDisabled={isLoadingCard} onClick={handleBtnClose}>
                    <IconClearClose />
                </Button>
            </Flex>

            <Flex gap='4px' className='modal_container-body'>
                <Loader isOpen={isLoadingCard} title={loadingTitle.value} backdrop />

                <Flex gap='15px' className='modal_container-content'>
                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='100px' className={!fieldsError.value.printStatus ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Статус печати <p className='pulse'></p></Flex>
                            <Input placeholder="Статус печати" isReadOnly {...txtPrintStatus}
                                    suffix={
                                        <DictSelectorContainer isScroll={false} isSearch={false} dictName="printStatus" onSelect={(data) => {
                                            txtPrintStatusID.setValue(Number(data.id))
                                            txtPrintStatus.setValue(data.name || '')
                                        }}>{getInputButton('select')}</DictSelectorContainer>
                                    }  
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='100px' className={!fieldsError.value.diplomNumber ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Дата выдачи документа <p className='pulse'></p></Flex>
                            <Input placeholder="Дата выдачи документа" type='mask' mask='99.99.9999' {...txtDiplomDate} 
                                suffix={
                                    <SelectDate currentDate={txtDiplomDate.value} onSelect={(date) => { txtDiplomDate.setValue(date) }}>
                                        {getInputButton('calendar')}
                                    </SelectDate>
                                }
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='100px' className={!fieldsError.value.diplomRegNumber ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Рег. № документа <p className='pulse'></p></Flex>
                            <Input placeholder="Рег. № документа" {...txtDiplomRegNumber} />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='100px' className={!fieldsError.value.diplomNumber ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems='center' className="input_header">Номер документа <p className='pulse'></p></Flex>
                            <Input placeholder="Номер документа" {...txtDiplomNumber} />
                        </Flex>
                    </Flex>
                </Flex>

                <Flex gap='6px' flexDirection='row' flexWrap='wrap' justifyContent='space-between'>
                    <Button variant='primaryDark' flexGrow={1} flexBasis='100px' 
                        onClick={() => handlerOpenModalConfirm(true, 'Вернуть на обработку', `Вы действительно хотите вернуть в обработку следующего слушателя:<br />👉 ${fullNameFrom}.`)}
                    >Удалить</Button>

                    <Button flexGrow={1} flexBasis='140px' isDisabled={isDisableBtnSave.value || isLoadingCard} onClick={() => handlerBtnSave(true)}>Сохранить и закрыть</Button>
                    <Button flexGrow={1} flexBasis='100px' isDisabled={isDisableBtnSave.value || isLoadingCard} onClick={() => handlerBtnSave(false)}>Сохранить</Button>
                </Flex>
            </Flex>
        </Flex>
    </Modal>
}